import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
        file: {
            type:     Object,
            required: true
        },
        url:  {
            type:     String,
            required: true
        }
    },
  setup(__props) {

const props = __props



const { file, url } = toRefs( props );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-full h-full bg-no-repeat bg-cover bg-center rounded-md",
    style: _normalizeStyle(`background-image: url('${_unref(file).url}')`)
  }, null, 4))
}
}

})